import React, {PropTypes} from 'react';
import Display from './parts/display';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from './../actions/siteActions';
import { browserHistory, Link } from 'react-router';


class LoginPage extends React.Component {
    constructor() {
        super();
        this.state = {
            username: '',
            password: ''
        };

        this.updateField = this.updateField.bind(this);
        this.login = this.login.bind(this);
    }
    componentWillMount(){
        window.scrollTo(0,0);

        if(sessionStorage){
            if(sessionStorage.getItem('user')){
                browserHistory.push('/private-portfolio');
            }
        }
    }
    componentDidMount() {
        this.props.actions.showNavBar(true);
        this.props.actions.showMenu(true);
    }
    componentWillUnmount(){
        this.props.actions.clearState();
    }
    componentWillReceiveProps(nextProps){
        if(this.props.site.user !== nextProps.site.user){
            if(nextProps.site.user){
                browserHistory.push('/private-portfolio');
            }
        }
    }
    updateField(e){
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    login(){
        this.props.actions.getUserToken({
            username: this.state.username,
            password: this.state.password,
        });
    }
    render() {
        return (
            <div className="services-page animated fadeIn login-page">
                <div className="login-box">
                    <p>Please type your username and password below.</p>
                    <Display if={this.props.site.loginError}><p className="error">{this.props.site.loginError.message}</p></Display>
                    <div className="login-form">
                        <div className="input-wrapper">
                            <input type="text" placeholder="Username" name="username" onChange={this.updateField}/>
                        </div>
                        <div className="input-wrapper">
                            <input type="password" placeholder="Password" name="password" onChange={this.updateField}/>
                        </div>
                        <div className="btn pull-right" onClick={this.login} disabled={this.props.site.loggingIn}>{ this.props.site.loggingIn? "Logging in...": "Login"}</div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        site: state.site
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



/** WEBPACK FOOTER **
 ** ./src/js/components/login.js
 **/